export default __webpack_public_path__ + "static/media/location--3.e2eb7137.jpg";